import { encodeDelimitedArray, decodeDelimitedArray } from 'use-query-params';
import { startCase, camelCase, sortBy } from 'lodash';

// convert array into a map search query
export function generateGoogleMapsSearchURL(values) {
  const baseURL = 'https://www.google.com/maps/search/?api=1&query=';
  // remove null values and join with ' '
  const query = values.filter((value) => value).join(' ');

  if (!query) {
    return undefined;
  }

  return baseURL + encodeURIComponent(query);
}

/** Uses a comma to delimit entries. e.g. ['a', 'b'] => qp?=a,b */
export const CommaArrayParam = {
  encode: (array) => encodeDelimitedArray(array, ','),
  decode: (arrayStr) => decodeDelimitedArray(arrayStr, ','),
};

function convertFilterSet(filterSet) {
  const filterArray = [];
  filterSet.forEach((display) => {
    filterArray.push(createFilterFromDisplay(display));
  });
  return sortBy(filterArray, ['display']);
}

// create filter obj from title case display
function createFilterFromDisplay(display) {
  return { name: camelCase(display), display };
}

// create filter obj from camel case name
function createFilterFromName(name) {
  return { name, display: startCase(name) };
}

// merge derived filter options with options only present in query parameters
export function generateFilters(derivedFilters, queryFilters) {
  let allFilters = convertFilterSet(derivedFilters);
  if (queryFilters) {
    queryFilters.forEach((queryFilter) => {
      // check for dupes in camel case to prevent duplicate filters
      // with different capitalization
      if (!allFilters.some((filter) => filter.name === queryFilter)) {
        allFilters.push(createFilterFromName(queryFilter));
      }
    });
  }
  return sortBy(allFilters, ['display']);
}
